import { render, staticRenderFns } from "./OngoingEventForm.vue?vue&type=template&id=b6e8563a&"
import script from "./OngoingEventForm.vue?vue&type=script&lang=js&"
export * from "./OngoingEventForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports